// @ts-check
import React, { useMemo } from 'react';
import DivisionTable from './DivisionTable';
import useStaffProfiles from "../useStaffProfiles";

const DivisionSort = () => {
  const { data, loading } = useStaffProfiles('division');

  const divisionResults = useMemo(() => {
    /** @type {Record<string, import("../useStaffProfiles").StaffProfile[]>} */
    let _divisionResults = {};
    const sortedData = data.sort((a, b) => (a.division > b.division ? 1 : -1));
    sortedData.forEach(d => {
      const division = d.division;
      if (_divisionResults[division]) {
        _divisionResults[division].push(d);
      } else {
        _divisionResults[division] = [d];
      }
    });

    return Object.entries(_divisionResults);
  }, [data.length]);

  return (
    <div>
      {divisionResults.map(([division, staff]) => (
        <DivisionTable 
          key={division} 
          loading={loading} 
          header={division} 
          staff={staff} 
        />
      ))}
    </div>
  );
};

DivisionSort.propTypes = {};

export default DivisionSort;
